export default function isTextEmpty(json) {
  if (!json) {
    return true;
  }
  if (json.hasOwnProperty('content') && !json?.content) {
    return true;
  }
  if (
    json.hasOwnProperty('content') &&
    json.content.length === 1 &&
    json.content[0].type === 'paragraph' &&
    !json.content[0].content
  ) {
    return true;
  }
  if (json?.html) {
    if (json.html?.features && /"isEmpty":true/.test(json.html?.features)) {
      return true;
    }
  }
  return false;
}
